class ProductModal extends ModalDialog {
  constructor () {
    super()
    if (window.matchMedia('(pointer: coarse)').matches) {
      this.initPinchZoom()
      this.initPinchToOpen()
    }
  }

  hide () {
    this.syncGalleryToVisibleMedia()

    const opener = this.openedBy
    this.openedBy = null
    super.hide()
    this.openedBy = opener
    opener?.focus({ preventScroll: true })

    this.resetAllZoom()
  }

  syncGalleryToVisibleMedia () {
    const visibleMedia = Array.from(this.querySelectorAll('[data-media-id]')).find(el => {
      const rect = (el.closest('.product-media-modal__item') || el).getBoundingClientRect()

      return rect.left <= window.innerWidth / 2 && rect.right >= window.innerWidth / 2 &&
        rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2
    })

    if (!visibleMedia) return

    const opener = document.querySelector(`modal-opener[data-modal="#${this.id}"] button[data-media-id="${visibleMedia.dataset.mediaId}"]`)

    if (!opener || opener === this.openedBy) return

    const carousel = opener.closest('product-media')?.carousel
    const slideIndex = carousel?.slides?.findIndex(slide => slide.contains(opener))

    if (slideIndex >= 0) carousel.moveToIdx(slideIndex, false, { duration: 0 })

    this.openedBy = opener
  }

  show (opener) {
    super.show(opener)
    this.showActiveMedia()
  }

  showActiveMedia () {
    const activeMediaId = this.openedBy.dataset.mediaId
    const modalImages = Array.from(this.querySelectorAll('[data-media-id]'))

    if (!activeMediaId) return

    const activeMedia = modalImages.filter(el => el.dataset.mediaId === activeMediaId)
    activeMedia[0].scrollIntoView()
    const sliderTrack = this.querySelector('.product-media-modal__list')

    if (!sliderTrack) return

    const activeSlide = activeMedia[0].closest('.product-media-modal__item') || activeMedia[0]

    sliderTrack.scrollTo({
      left: activeSlide.offsetLeft,
      behavior: 'instant',
    })
  }

  initPinchZoom () {
    const modalImages = Array.from(this.querySelectorAll('[data-media-id]'))

    this.pinchZooms = modalImages.map(el => new PinchZoom(el, {
      draggableUnzoomed: false,
      onZoomStart: pz => {
        pz.startedZoomedOut = pz.zoomFactor <= 1.01
        pz.pinchedPastMin = false
      },
      onZoomUpdate: pz => {
        if (pz.zoomFactor < 0.8) pz.pinchedPastMin = true
      },
    }))

    this.pinchZooms.forEach(pz => {
      pz.container.addEventListener('touchend', event => {
        if (event.touches.length || !pz.startedZoomedOut || !pz.pinchedPastMin) return

        pz.startedZoomedOut = false
        this.hide()
      })
    })

    const sliderTrack = this.querySelector('.product-media-modal__list')

    if (!sliderTrack) return

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) return

        const pz = this.pinchZooms.find(pz => pz.container === entry.target)
        if (pz) this.resetZoom(pz)
      })
    }, { root: sliderTrack, threshold: 0.01 })

    this.pinchZooms.forEach(pz => observer.observe(pz.container))
  }

  initPinchToOpen () {
    const openers = document.querySelectorAll(`modal-opener[data-modal="#${this.id}"]`)

    openers.forEach(opener => {
      const button = opener.querySelector('button')

      if (!button) return

      let isPinching = false

      opener.addEventListener('touchstart', event => {
        if (event.touches.length !== 2) return

        isPinching = true
        event.preventDefault()
        button.click()
      }, { passive: false })

      opener.addEventListener('touchmove', event => {
        if (!isPinching) return

        event.preventDefault()
        event.stopPropagation()
      }, { passive: false })

      opener.addEventListener('touchend', event => {
        if (!event.touches.length) isPinching = false
      })

      opener.addEventListener('gesturestart', event => event.preventDefault())
    })
  }

  resetZoom (pz) {
    if (pz.zoomFactor === 1) return

    pz.stopAnimation()
    pz.zoomFactor = 1
    pz.resetOffset()
    pz.update()
  }

  resetAllZoom () {
    if (!this.pinchZooms) return

    this.pinchZooms.forEach(pz => this.resetZoom(pz))
  }
}

customElements.define('product-modal', ProductModal)
